module.exports = __webpack_public_path__ + "img/canvasMenuEnd.a38ff2af.svg";